import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "toggle__switcher-circle" }
const _hoisted_3 = {
  key: 0,
  class: "toggle__text"
}

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'toggle',
  props: {
  text: { type: String, default: "" },
  nameID: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const isActive = ref(false);

onMounted(() => {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: `#toggle-${props.nameID}`,
    start: "top 90%",
    endTrigger: `#toggle-${props.nameID}`,
    end: "bottom",
    onToggle: (self) => {
      if (self.isActive) isActive.value = self.isActive;
    },
  });
});

return (_ctx: any,_cache: any) => {
  const _component_logo = _resolveComponent("logo")!

  return (_openBlock(), _createElementBlock("div", {
    id: `toggle-${__props.nameID}`,
    class: "toggle"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'toggle__switcher',
        [isActive.value ? 'toggle--active' : 'toggle--disabled'],
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (isActive.value)
          ? (_openBlock(), _createBlock(_component_logo, {
              key: 0,
              color: "#ffffff"
            }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (__props.text.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})